import { defineMessages } from 'react-intl';

export default defineMessages({
    title: {
        id: 'app.formSuccess.title',
        defaultMessage: 'Great!'
    },
    text: {
        id: 'app.formSuccess.text',
        defaultMessage: 'You will be redirected in'
    }
});
